import Immutable, { Record } from 'immutable';
import { Gender } from 'omni-common-ui';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'gender':
      return [key, Gender.parse(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

const StudentRecord = Record({
  avatarUrl: undefined,
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  gender: undefined,
  studentNumber: undefined,
  localName: undefined,
});

class Student extends StudentRecord {
  static create(data) {
    return new Student(data).mapEntries(reviver);
  }
}

export default Student;



// WEBPACK FOOTER //
// ./containers/Student/model.js